module.exports = __webpack_public_path__ + "img/sendpic.e8228a62.png";